module.exports = __webpack_public_path__ + "img/logofund.c70d1345.svg";